import { FC, useState } from "react";
import { Dropdown, Menu, Space, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  GetParkingListResponse,
  MasterTransport,
  ParkingListItems,
} from "services/interface";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { convertTransport } from "utils/convertData";
import ModalCreateDeliveryPoint from "../ModalCreateDeliveryPoint";
import { useGetParkingList } from "hooks/useShipping";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";
interface TableTransportationListProps {
  data: MasterTransport[] | undefined;
  onDeleteConfigs: (id: string) => void;
}

const TableTransportationList: FC<TableTransportationListProps> = ({
  data,
  onDeleteConfigs,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [showDetail, setShowDetail] = useState(false);
  const [masterTransportId, setMasterTransportId] = useState<string>("");

  const [modalData, setModalData] = useState<
    GetParkingListResponse | undefined
  >(undefined);
  const { mutate } = useGetParkingList();

  const refetch = (id: string) => {
    mutate(id, {
      onSuccess: async (data) => {
        setModalData(data);
        setMasterTransportId(id);
      },
      onError: (error) => {
        console.log(error);
        dispatch(setLoading(false));
      },
    });
  };
  const columns: ColumnsType<MasterTransport> = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      align: "center",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "ชื่อขนส่ง",
      dataIndex: "name",
      render: (_text, record) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
            type="secondary"
            onClick={async () => {
              // dispatch(setLoading(true));
              // mutate(record.id, {
              //   onSuccess: async (data) => {
              //     setModalData(data);
              //     await new Promise((resolve) => setTimeout(resolve, 200));
              //     setMasterTransportId(record.id);
              //     setShowDetail(true);
              //     dispatch(setLoading(false));
              //   },
              //   onError: (error) => {
              //     console.log(error);
              //     dispatch(setLoading(false));
              //   },
              // });
              navigate(`update/${record.id}`);
            }}
          >
            {_text}
          </Typography.Link>
        );
      },
    },

    // {
    //   title: "หมายเลขรถ",
    //   dataIndex: "car_no",
    //   align: "center",
    //   render: (_text) => {
    //     return <Typography.Paragraph >{_text}</Typography.Paragraph>;
    //   },
    // },
    // {
    //   title: "ทะเบียนรถ",
    //   dataIndex: "license_plate",
    //   align: "center",
    //   render: (_text) => {
    //     return <Typography.Paragraph >{_text}</Typography.Paragraph>;
    //   },
    // },
    // {
    //   title: "ประเภทขนส่ง",
    //   dataIndex: "type",
    //   align: "center",
    //   render: (_text) => {
    //     return <Typography.Paragraph >{convertTransport(_text)}</Typography.Paragraph>;
    //   },
    // },
    // {
    //   title: "ค่าส่ง",
    //   dataIndex: "service_price",
    //   align: "center",
    //   render: (_text) => {
    //     return <Typography.Paragraph >{_text}</Typography.Paragraph>;
    //   },
    // },

    // {
    //   title: "จังหวัดต้นทาง",
    //   align: "left",
    //   dataIndex: "province_name_start",
    //   render: (_text) => {
    //     return <Typography.Paragraph>{_text}</Typography.Paragraph>;
    //   },
    // },
    // {
    //   title: "จังหวัดปลายทาง",
    //   align: "left",
    //   dataIndex: "province_name_end",
    //   render: (_text) => {
    //     return <Typography.Paragraph>{_text}</Typography.Paragraph>;
    //   },
    // },
    // {
    //   title: "เวลาออกรถ",
    //   align: "left",
    //   render: (_text, record) => {
    //     return (
    //       <Typography.Paragraph>
    //         {record.time_start}
    //       </Typography.Paragraph>
    //     );
    //   },
    // },
    {
      title: "ประเภทขนส่ง",
      align: "left",
      render: (_text, record) => {
        return (
          <Typography.Paragraph>
            {convertTransport(record.type)}
          </Typography.Paragraph>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "transection_code",
      align: "center",
      key: "transection_code",
      fixed: "right",
      width: 100,
      render: (_text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Space size="middle">
            <Dropdown
              overlay={
                <Menu>
                  {/* <Menu.Item
                    key="0"
                    onClick={() => {
                      dispatch(setLoading(true));
                      mutate(record.id, {
                        onSuccess: async (data) => {
                          setModalData(data);
                          await new Promise((resolve) =>
                            setTimeout(resolve, 200)
                          );
                          setMasterTransportId(record.id);
                          setShowDetail(true);
                          dispatch(setLoading(false));
                        },
                        onError: (error) => {
                          dispatch(setLoading(false));
                        },
                      });
                    }}
                  >
                    จัดการจุดจอด
                  </Menu.Item> */}
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      navigate(`update/${record.id}`);
                    }}
                  >
                    แก้ไข
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      onDeleteConfigs(record.id);
                    }}
                  >
                    ลบ
                  </Menu.Item>
                </Menu>
              }
            >
              <div>
                <EllipsisOutlined />
              </div>
            </Dropdown>
          </Space>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table scroll={{ x: true }} columns={columns} dataSource={data} />
      <ModalCreateDeliveryPoint
        id={masterTransportId}
        data={modalData?.data}
        open={showDetail}
        onClose={() => {
          setShowDetail(false);
        }}
        refetch={refetch}
      />
    </div>
  );
};

export default TableTransportationList;
